export const AdMedia = ({ ad, className = '', onEnded, autoLoop = true, videoRef }) => (
  ad.media_type === 'video' ? (
    <video
      ref={videoRef}
      src={ad.media_url}
      className={className}
      autoPlay
      muted={autoLoop}
      loop={autoLoop}
      playsInline
      onEnded={onEnded}
      onError={onEnded}
    />
  ) : (
    <img src={ad.media_url} alt={ad.advertiser_name || 'Advertisement'} className={className} loading="lazy" />
  )
);
